/* ==========================================================================
   Bold Grip Socks: colour picker on bundle product pages (Trio, 2/4/6/10-pack).
   Rows come from window.BM_COLORWAYS; men's colours join on the men's pack sizes.
   Keeps properties[Colors] (and Pre-order for pre-order colours) in sync.
   ========================================================================== */
(function () {
  'use strict';
  var T = window.BM_I18N || {};
  var CW = window.BMCW;
  function tt(s, tok, val) { return String(s).replace(tok, val); }

  var picker = document.querySelector('[data-bpicker]');
  if (!picker || !CW) return;
  var bundleSize = parseInt(picker.getAttribute('data-bundle-size'), 10);
  if (!bundleSize || bundleSize < 1) return;

  var $rows = picker.querySelector('[data-cw-rows]');
  var $total = picker.querySelector('[data-bpicker-total]');
  var $hint = picker.querySelector('[data-bpicker-hint]');
  var $prop = picker.querySelector('[data-bpicker-property]');
  var $atc = document.querySelector('[data-bpicker-atc]');
  var $atcLabel = document.querySelector('[data-bpicker-atc-label]');

  var P = { row: 'bm-bpicker__row', dot: 'bm-bpicker__dot', name: 'bm-bpicker__name', stepper: 'bm-bpicker__stepper', step: 'bm-bpicker__step', count: 'bm-bpicker__step-count', attr: 'data-bpicker' };
  var list = CW.forSize(bundleSize);
  var state = CW.defaultMix(list, bundleSize, null);
  if ($rows) $rows.innerHTML = CW.rowsHTML(list, P);

  var $boNote = null;
  function updateBoNote(ks) {
    if (ks.length) {
      if (!$boNote) {
        $boNote = document.createElement('p');
        $boNote.className = 'bm-backorder-note';
        if ($hint && $hint.parentNode) $hint.parentNode.insertBefore($boNote, $hint.nextSibling);
        else picker.appendChild($boNote);
      }
      $boNote.textContent = CW.notice(ks);
      $boNote.hidden = false;
    } else if ($boNote) { $boNote.hidden = true; }
  }

  function render() {
    var n = CW.total(state);
    list.forEach(function (c) {
      var sold = c.soldout;
      var el = picker.querySelector('[data-bpicker-count="' + c.key + '"]');
      if (el) el.textContent = state[c.key];
      var row = picker.querySelector('[data-bpicker-row="' + c.key + '"]');
      if (row) {
        row.classList.toggle('has-count', state[c.key] > 0 && !sold);
        row.classList.toggle('is-soldout', sold);
        if (sold && !row.querySelector('.bm-bpicker__soldout')) {
          var badge = document.createElement('span');
          badge.className = 'bm-bpicker__soldout';
          badge.textContent = T.soldOut || 'Sold out';
          var stepper = row.querySelector('.bm-bpicker__stepper');
          if (stepper) row.insertBefore(badge, stepper);
        }
      }
      var minus = picker.querySelector('[data-bpicker-minus="' + c.key + '"]');
      if (minus) minus.disabled = sold || state[c.key] === 0;
      var plus = picker.querySelector('[data-bpicker-plus="' + c.key + '"]');
      if (plus) plus.disabled = sold || (n >= bundleSize && state[c.key] >= n);
    });
    if ($total) $total.textContent = n;
    if ($prop) $prop.value = CW.colorsString(list, state);

    var ks = CW.backorderKeys(list, state);
    var form = $prop && $prop.form;
    if (form) {
      var $boIn = form.querySelector('input[name="properties[Pre-order]"]:not([data-bo-static])');
      if (ks.length) {
        if (!$boIn) {
          $boIn = document.createElement('input');
          $boIn.type = 'hidden';
          $boIn.name = 'properties[Pre-order]';
          form.appendChild($boIn);
        }
        $boIn.value = CW.property(ks);
      } else if ($boIn) { $boIn.remove(); }
    }
    updateBoNote(ks);

    if (n === bundleSize) {
      if ($atc) $atc.disabled = false;
      if ($atcLabel) $atcLabel.textContent = T.addToCart || 'Add to Cart';
      if ($hint) { $hint.textContent = '✓ ' + n + '/' + bundleSize + ' pairs picked · ' + (T.swapHint || 'tap + to swap a colour'); $hint.classList.add('is-ready'); }
    } else {
      var remaining = bundleSize - n;
      if ($atc) $atc.disabled = true;
      if ($atcLabel) $atcLabel.textContent = T.pickMorePair ? tt(T.pickMorePair, '[n]', remaining) : ('Pick ' + remaining + ' more pair' + (remaining === 1 ? '' : 's'));
      if ($hint) { $hint.textContent = T.pickMoreContinue ? tt(T.pickMoreContinue, '[n]', remaining) : ('Pick ' + remaining + ' more to continue'); $hint.classList.remove('is-ready'); }
    }
  }

  picker.addEventListener('click', function (e) {
    var btn = e.target.closest('button');
    if (!btn) return;
    var key = btn.getAttribute('data-bpicker-plus') || btn.getAttribute('data-bpicker-minus');
    if (!key || !state.hasOwnProperty(key)) return;
    e.preventDefault();
    e.stopPropagation();
    var c = CW.byKey(key);
    if (btn.hasAttribute('data-bpicker-plus')) {
      if (!c || c.soldout) return;
      if (CW.total(state) >= bundleSize) { if (!CW.swapInto(list, state, key)) return; render(); return; }
      state[key] += 1;
    } else {
      if (state[key] <= 0) return;
      state[key] -= 1;
    }
    render();
  });

  render();
})();
